import { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router';
import { useAuthContext, setUser } from '../contexts/AuthContext';
import { login as masterLogin } from '../services/Master';
import { login as studentLogin } from '../services/Student';
import CircularProgress from '@material-ui/core/CircularProgress';
import MainLayout, { InnerContainer } from './MainLayout';
import Login from './Login';

const UserHomeBase = ({ master }) => {
    const [errorMessages, setErrorMessages] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const history = useHistory();
    const location = useLocation();
    const { auth, dispatch } = useAuthContext();
    const { isAuthenticated, token, ready, gameStatus } = auth;

    useEffect(() => {
        function addError(msg) {
            setErrorMessages((prev) => [...prev, msg]);
        }

        const redirectLoggedInUser = () => {
            let destination;
            if (master) {
                destination = '/master/gamesettings';
            } else {
                destination = '/student/game';
            }
            history.push(destination);
        };

        let mounted = true;
        if (ready) {
            let query = new URLSearchParams(location.search);
            const key = query.get('key');
            if (isAuthenticated && (!key || key === token)) {
                redirectLoggedInUser();
            } else if (key) {
                // login user
                setIsLoading(true);
                setErrorMessages([]);

                const loginPromise = master
                    ? masterLogin(key)
                    : studentLogin(key);
                loginPromise
                    .then((userData) => {
                        if (mounted) {
                            if (userData.permissionLevel >= master ? 2 : 1) {
                                dispatch(
                                    setUser({ ...userData, token: key, master })
                                );
                                redirectLoggedInUser(userData.gameStatus);
                            } else {
                                addError('Permission denied');
                            }
                        }
                    })
                    .catch((error) => {
                        if (mounted)
                            addError(error.message || error.statusText);
                    })
                    .finally(() => {
                        if (mounted) setIsLoading(false);
                    });
            } else {
                // history.push('/');
                setIsLoading(false);
            }
        }
        return () => {
            mounted = false;
        };
    }, [
        location,
        ready,
        gameStatus,
        isAuthenticated,
        dispatch,
        history,
        master,
        token,
    ]);

    if (isLoading) {
        return <CircularProgress />;
    }

    return (
        <MainLayout>
            <InnerContainer>
                {/* key:{key} */}
                {!auth.isAuthenticated && auth.ready && (
                    <Login
                        master={master}
                        referrer={
                            master ? 'master/gamesettings' : 'student/game'
                        }
                    />
                )}
                {errorMessages.map((msg, i) => (
                    <p key={i}>{msg}</p>
                ))}
            </InnerContainer>
        </MainLayout>
    );
};
export default UserHomeBase;
